import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { selectMapTargetData } from '../../store/map/map.selectors'
import { useMapContext } from './MapContext'
import { useAction } from '../utils/react-redux'
import { acknowledgeZoom } from '../../store/map/map.actions'

export default function useMapZoomHandler() {
  const { targetZoom } = useSelector(selectMapTargetData)
  const { map } = useMapContext()
  const execAcknowledgeZoom = useAction(acknowledgeZoom)

  useEffect(() => {
    if (!map || !targetZoom) return

    execAcknowledgeZoom()

    map.zoomTo(targetZoom)
  }, [map, targetZoom])
}
